import { useState } from "react";
import {
  SingleSelectKendoGridToolbarItem,
  SingleSelectKendoGridToolbarItemProps,
} from "./SingleSelectKendoGridToolbarItem";
import MdmKendoGrid from "../MdmKendoGrid";
import { MdmGridProps } from "../MdmGridProps";
import { GRID_SELECTED_FIELD } from "./GridSelection";

type SelectableKendoGridProps<T> = {
  mapResults?: (item: T) => T;
  toolbarItems?: SingleSelectKendoGridToolbarItemProps<T | undefined>[];
  localStorageKey: string;
};

export default function SingleSelectKendoGrid<TData, TExport>({
  idSelector,
  localStorageKey,
  toolbarItems = [],
  mapResults = (item: TData) => item,
  refetchedData,
  handleDataState,
  ...otherProps
}: SelectableKendoGridProps<TData> & MdmGridProps<TData, TExport>) {
  const [selectedItem, setSelectedItem] = useState<TData | undefined>();

  const isItemSelected = (item: TData) =>
    !!selectedItem && idSelector(item) === idSelector(selectedItem);

  const markSelectedItem = (item: TData) => ({
    ...mapResults(item),
    [GRID_SELECTED_FIELD]: isItemSelected(item),
  });

  const toolbarButtons = toolbarItems.map((itemProps) => (
    <SingleSelectKendoGridToolbarItem
      key={itemProps.text}
      selection={selectedItem}
      {...itemProps}
    />
  ));

  return (
    <MdmKendoGrid
      idSelector={idSelector}
      selection={selectedItem ? [selectedItem] : []}
      localStorageKey={localStorageKey}
      mapItem={markSelectedItem}
      onDataStateChanged={() => setSelectedItem(undefined)}
      onRowClick={(item) => setSelectedItem(isItemSelected(item) ? undefined : item)}
      toolbarItems={toolbarButtons}
      refetchedData={refetchedData}
      handleDataState={handleDataState}
      {...otherProps}
    />
  );
}
